import { types } from 'actions/projects/send_links_button_actions'

const initialState = {
  availableProjects: []
}

function reducer (state = initialState, action) {
  switch (action.type) {
    case types.LOAD_PROJECTS:
      return {
        ...state,
        availableProjects: action.data || []
      }
  }
  return state
}

export default reducer
